import type {ShapeItemObject} from '@PosterWhiteboard/items/item/item.types';
import type {RGBA} from '@Utils/color.util';

import type {VectorItemSource} from '@PosterWhiteboard/items/vector-item/vector-item.library';

export interface VectorItemObject extends ShapeItemObject {
  fileName: string;
  source: VectorItemSource;
  isCustomisable: boolean;
  forceUniformFill: boolean;
}

/** Keep in sync with $ct-neutral-secondary ($gray-70, #757589) in public/assets/css/components/core/tokens/_content.scss. */
export const PMW_SHAPE_DEFAULT_FILL: RGBA = [117, 117, 137, 1];
